export default class Tab {
  constructor(public name: string='unnamed') {}
}